<div id="busca-hoteis">
  <div class="columns">
    <div class="column is-9">
      <div class="form-group input-search">
        <i class="far fa-map-marker"></i>
        <i class="far fa-search"></i>
        <p-autoComplete class="form-control w-100 h-auto-complete"
                        field="data.nome"
                        [(ngModel)]="brand"
                        [style]="{'font-size': fontSize}"
                        [suggestions]="filteredBrands"
                        (completeMethod)="filterBrands($event)"
                        (onSelect)="selectInAutoComplete()"
                        [size]="size"
                        [minLength]="1"
                        [placeholder]="placeholder">
          <ng-template let-brand pTemplate="item" class="w-100 h-auto-complete">
            <div class="ui-helper-clearfix" style="border-bottom:1px solid #D5D5D5">
              <div style="width:auto;display:inline-block;margin:5px 0 2px 5px">
                <p>{{getNomeAutoComplete(brand)}} <br>
                  <small>{{getDetalheAutoComplete(brand)}}</small></p>
              </div>
            </div>
          </ng-template>
        </p-autoComplete>
      </div>
    </div>
  </div>
</div>
